// i18n namespace "meta" (WP-C): document titles and descriptions per route, and
// the 404 page. Eager (small). Spanish uses tú. No claims (spec c.11).

export const en = {
  title: "DuxTrans — Senior SAP consulting for Mexico and the Americas",
  description:
    "Senior SAP S/4HANA consultants for finance, logistics and CFDI e-invoicing in Mexico and the Americas. Talk to an SAP expert.",
  careersTitle: "Open roles · DuxTrans Careers",
  jobTitle: "{{title}} · DuxTrans Careers",
  closedTitle: "Role closed · DuxTrans Careers",
  privacyTitle: "Privacy notice · DuxTrans",
  termsTitle: "Terms of use · DuxTrans",
  notFoundTitle: "Page not found · DuxTrans",
  notFound: {
    label: "Error 404",
    heading: "We can’t find that page",
    lead: "The link may be old or mistyped. Everything on the site starts from the home page.",
    home: "Go to the home page",
  },
};

export const es = {
  title: "DuxTrans — Consultoría SAP senior para México y las Américas",
  description:
    "Consultores SAP S/4HANA senior para finanzas, logística y facturación electrónica CFDI en México y las Américas. Habla con un experto SAP.",
  careersTitle: "Vacantes abiertas · DuxTrans",
  jobTitle: "{{title}} · Vacantes DuxTrans",
  closedTitle: "Vacante cerrada · DuxTrans",
  privacyTitle: "Aviso de privacidad · DuxTrans",
  termsTitle: "Términos de uso · DuxTrans",
  notFoundTitle: "Página no encontrada · DuxTrans",
  notFound: {
    label: "Error 404",
    heading: "No encontramos esa página",
    lead: "Puede que el enlace sea antiguo o tenga un error. Todo el sitio parte de la página de inicio.",
    home: "Ir al inicio",
  },
};

export const fr = {
  title: "DuxTrans — Conseil SAP senior pour le Mexique et les Amériques",
  description:
    "Consultants SAP S/4HANA seniors en finance, logistique et facturation électronique CFDI au Mexique et dans les Amériques. Parlez à un expert SAP.",
  careersTitle: "Postes ouverts · Carrières DuxTrans",
  jobTitle: "{{title}} · Carrières DuxTrans",
  closedTitle: "Poste pourvu ou fermé · Carrières DuxTrans",
  privacyTitle: "Politique de confidentialité · DuxTrans",
  termsTitle: "Conditions d’utilisation · DuxTrans",
  notFoundTitle: "Page introuvable · DuxTrans",
  notFound: {
    label: "Erreur 404",
    heading: "Cette page est introuvable",
    lead: "Le lien est peut-être ancien ou mal saisi. Tout le site part de la page d’accueil.",
    home: "Aller à l’accueil",
  },
};

export const pt = {
  title: "DuxTrans — Consultoria SAP sênior para o México e as Américas",
  description:
    "Consultores SAP S/4HANA sêniores em finanças, logística e faturamento eletrônico CFDI no México e nas Américas. Fale com um especialista SAP.",
  careersTitle: "Vagas abertas · Carreiras DuxTrans",
  jobTitle: "{{title}} · Carreiras DuxTrans",
  closedTitle: "Vaga encerrada · Carreiras DuxTrans",
  privacyTitle: "Aviso de privacidade · DuxTrans",
  termsTitle: "Termos de uso · DuxTrans",
  notFoundTitle: "Página não encontrada · DuxTrans",
  notFound: {
    label: "Erro 404",
    heading: "Não encontramos esta página",
    lead: "O link pode estar desatualizado ou digitado errado. Todo o site começa pela página inicial.",
    home: "Ir para o início",
  },
};
